import { ListGroup, DrawerItem } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router";
import {
  Feedback,
  PersonAdd,
  VpnKey,
  AccountCircle,
	Email,
  Inventory2,
} from "@mui/icons-material";
import { GroupedSideBar } from "../unprotected/GroupedSideBar";
import { UngroupedSideBar } from "./UngroupedSideBar";
import FeatureFlag from "@/components/FeatureFlag/FeatureFlag";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import NewsletterDrawerItem from "@/components/Newsletter/navigation/NewsletterDrawerItem";

export const MainDrawerItems = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  	
  const navigateChangePassword = () => {
    if (Settings.features?.oidc && Settings.oidc) {
      window.location.href = Settings.oidc.changePasswordUrl;
    } else {
      navigate(t('common:url.changePassword'))
    }
  }

  const ProfileListGroup = <ListGroup
    icon={<AccountCircle />}
    titleLabel={t('common:text.my_profile_title')}
    startOpen={[t('common:url.changePassword'), t('common:url.newsletter')].includes(location.pathname)}
  >
		{Settings?.newsletter?.enabled && <NewsletterDrawerItem />}

    <DrawerItem
      icon={<VpnKey />}
      label={t('common:text.change_password_view_title')}
      onClick={() => navigateChangePassword()}
      selected={location.pathname == t('common:url.changePassword')}
    />
  </ListGroup>

  return <>
    {!Settings.sidebar?.groups && <UngroupedSideBar />}

    {ProfileListGroup}
    {Settings.features?.reclamATCMenu && <DrawerItem
      icon={<Feedback />}
      label={t('common:text.reclamations_title')}
      onClick={() => navigate(t('common:url.reclamations'))}
      selected={location.pathname == t('common:url.reclamations')}
    />}
    {Settings.features?.showDocumentRepository && <DrawerItem
      icon={<Inventory2 />}
      label={t('common:text.document_repository_title')}
      onClick={() => navigate(t('common:url.document_repository'))}
      selected={location.pathname == t('common:url.document_repository')}
    />}
    {Settings.features?.contact && (
      <FeatureFlag flagName="crm.case">
        <DrawerItem
          icon={<PersonAdd />}
          label={t('common:text.contact_title')}
          onClick={() => navigate(t('common:url.contact'))}
          selected={location.pathname == t('common:url.contact')}
        />
      </FeatureFlag>
    ) }

  </>
}